import { render } from "./UnauthorizedIndexComponent.vue?vue&type=template&id=141cb650&scoped=true"
import script from "./UnauthorizedIndexComponent.vue?vue&type=script&lang=js"
export * from "./UnauthorizedIndexComponent.vue?vue&type=script&lang=js"

import "./UnauthorizedIndexComponent.vue?vue&type=style&index=0&id=141cb650&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141cb650"]])

export default __exports__